import { DateTime } from 'luxon';
import * as React from 'react';
import { Calendar } from '../../components/calendar/calendar';
import {
    DocumentUserPlanningFragment,
    EventsDocumentInput,
    PsuiUserPlanningFragment,
    UserPlanningDocumentOptions
} from '../../generated/types';
import { parseTime } from '../../util/time';
import { UserPlanningContainer } from './userPlanningContainer';
import { UserPlanningPosition } from './userPlanningPosition';

interface IUserPlanningPageProps {
    assignments: PsuiUserPlanningFragment[];
    document: EventsDocumentInput;
    options: UserPlanningDocumentOptions;
    event: DocumentUserPlanningFragment;
    startDate: DateTime;

    renderText(text: string): string;
}

export const UserPlanningPage = (props: IUserPlanningPageProps) => {
    const [startHour] = parseTime(props.event.dayStartTime)!;

    return (
        <UserPlanningContainer
            document={props.document}
            event={props.event}
            options={props.options}
            renderText={props.renderText}
            startDate={props.startDate}
        >
            <Calendar.Root
                css={{
                    border: '1px solid $gray200',
                    borderRadius: '$2',
                    height: '100%',
                    overflow: 'hidden',
                    '& .h-calendar-events-container': {
                        height: '100% !important'
                    }
                }}
                date={props.startDate}
                maxDate={props.event.endAt}
                minDate={props.event.startAt}
            >
                {props.assignments.map((psui) => (
                    <Calendar.Event
                        key={psui.id}
                        endAt={psui.positionSlot.range.start!}
                        startAt={psui.positionSlot.range.start!}
                        startHour={startHour}
                    >
                        <UserPlanningPosition psui={psui} startHour={startHour} />
                    </Calendar.Event>
                ))}
            </Calendar.Root>
        </UserPlanningContainer>
    );
};
